var env = {}
env.local = {
	mode: 'local',
	ApiURL: 'https://api.sbz.vn/4.0',
	RealtimeURL: 'https://rt-0.sbz.vn/',
	BaseURL: '//localhost:8081',
	FileURL: 'https://file-subiz.com',
	BackendURL: 'https://widget.sbz.vn',
	PublicPath: '/',
}

env.development = {
	mode: 'dev',
	ApiURL: 'https://api.subiz.net/4.0',
	RealtimeURL: 'https://rt-0.subiz.net/',
	BaseURL: 'https://widgetv4.subiz.net',
	FileURL: 'https://filev4.subiz.net',
	BackendURL: 'https://widget-4.subiz.net',
	PublicPath: 'https://public-gcs.subiz-cdn.com/widget-v4/dev',
}

env.production = {
	mode: 'prod',
	ApiURL: 'https://api.sbz.vn/4.0',
	RealtimeURL: 'https://rt-0.sbz.vn/',
	// RealtimeURL: 'https://realtime-0.subiz.com/',
	BaseURL: 'https://widget.sbz.vn',
	FileURL: 'https://file-subiz.com',
	BackendURL: 'https://widget.sbz.vn',
	PublicPath: 'https://public-gcs.subiz-cdn.com/widget-v4/public/',
}

module.exports = env[process.env.NODE_ENV || 'production']
